import { RootState } from '../../../../../init-store';

export const getNotificationHeaderText = (state: RootState): string => {
    return state.notifications.confirmNotification.headerText;
};

export const getNotificationContentText = (state: RootState): string => {
    return state.notifications.confirmNotification.contentText;
};

export const selectIsCrosspageNotification = (state: RootState): boolean => {
    return Boolean(state.notifications.confirmNotification.crosspage);
};
